"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathEvaluator = void 0;
class MathEvaluator {
    async evaluate(submission, activity) {
        const expectedAnswer = String(activity.config.expectedAnswer ?? '');
        const expression = String(activity.config.expression ?? '');
        const studentAnswerRaw = submission.structuredData?.answer ?? submission.finalText ?? '';
        const studentAnswer = String(studentAnswerRaw).trim();
        let isCorrect = false;
        let feedback = '';
        let score = 0;
        if (expectedAnswer === '') {
            isCorrect = studentAnswer.length > 0;
            score = isCorrect ? 50 : 0;
            feedback = isCorrect ? 'Answer recorded.' : 'No answer provided.';
        }
        else {
            // Try numeric comparison with tolerance
            const expectedNum = parseFloat(expectedAnswer);
            const studentNum = parseFloat(studentAnswer);
            if (!isNaN(expectedNum) && !isNaN(studentNum)) {
                const tolerance = Math.abs(expectedNum) * 0.01 + 0.001; // 1% + 0.001 absolute
                isCorrect = Math.abs(expectedNum - studentNum) <= tolerance;
            }
            else {
                isCorrect = studentAnswer.toLowerCase() === expectedAnswer.toLowerCase();
            }
            score = isCorrect ? 100 : 0;
            feedback = isCorrect
                ? 'Correct! Well done.'
                : `Not quite. The expected answer was ${expectedAnswer}.`;
        }
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                { name: 'Accuracy', score, maxScore: 100, feedback: isCorrect ? 'Exact match within tolerance' : 'Answer did not match expected value' },
            ],
            skills: [{ key: `maths:${expression.replace(/\s+/g, '')}`, label: `Maths: ${expression}` }],
            label: 'Maths Score',
        };
    }
}
exports.MathEvaluator = MathEvaluator;
